<template>
  <div class="container">
    <a-row>
      <a-layout-content>
        <T1WelcomeSection />
        <T1MainSearcher
          :isSkione="getDomainType('', 'skione') ? true : false"
	  :isFront=true
        />
        <T1Onas />
        <T1TopOffers />
        <template v-if="getDomainType('travelone', 'skione')">
          <T1TopRegionyHome />
          <T1Przewodnik />
        </template>
        <template v-else>
          <T1ScrollOferty />
          <T1Przewodnik />
          <T1TopRegionyHome />
        </template>
        <T1TravelplanetCta
          :isSkione="getDomainType('', 'skione') ? true : false"
        />
      </a-layout-content>
    </a-row>
  </div>
</template>

<script>
import T1Onas from "./T1Onas";
import T1TopRegionyHome from "./T1TopRegiony/T1TopRegionyHome";
// import T1ScrollOferty from "./T1ScrollOferty";
import T1TopOffers from "./T1TopOffers";
import T1MainSearcher from "./T1Searchers/T1MainSearcher";
import T1WelcomeSection from "./T1WelcomeSection";
import T1TravelplanetCta from "./T1Assets/T1TravelplanetCta";
import T1Przewodnik from "./T1Przewodnik";
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

export default {
  name: "home-page-content",
  mixins: [domainTypeMixin],
  components: {
    T1Onas,
    T1TopRegionyHome,
    // T1ScrollOferty,
    T1TopOffers,
    T1MainSearcher,
    T1WelcomeSection,
    T1TravelplanetCta,
    T1Przewodnik,
  },
};
</script>
